"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function () { return ({
    root: {
        width: '100%',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'hidden',
        position: 'relative'
    },
    body: {
        height: '100%'
    }
}); });
exports.default = useStyles;
